import { render } from "./influence-factor.vue?vue&type=template&id=ca0b12bc&scoped=true"
import script from "./influence-factor.vue?vue&type=script&lang=js"
export * from "./influence-factor.vue?vue&type=script&lang=js"

import "./influence-factor.vue?vue&type=style&index=0&id=ca0b12bc&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\86131\\Desktop\\睿捷项目\\face-pro-test\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca0b12bc"]])

export default __exports__